@if(!is_inline){ @if(!hideHeader){
<my-delivery-header></my-delivery-header>
}@else{

<div class="py-3 px-5 border-b">
  <div class="mobileCloseIcon justify-between flex">
    <p class="mobile-title m-0 font-semibold text-[16px] text-[#1E1E20]">Upload Files</p>
    <div>
      <button
        mat-icon-button
        tabindex="-1"
        style="padding: 0px; height: 24px; width: 24px; position: relative; top: -10px; left: -4px"
        (click)="minimizeMxDialog()"
      >
        <mat-icon>minimize</mat-icon>
      </button>
      <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closeDialog()">
        <span style="font-size: 24px; font-weight: 400; color: #25508e" class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  </div>
</div>
} }

<div class="flex flex-col">
  <section class="h-[90%]">
    <div
      class="flex flex-col w-full sm:h-[100%] my-[16px]"
      [style.max-width]="!is_mobile_delivery ? 'calc(100% - 48px)' : '880px'"
      style="width: calc(100% - 48px) !important; margin: auto"
    >
      @if(!hideHeader){
      <div class="m-0 text-lg text-[#53565b] flex items-start flex-col">
        <p [class]="screenWidth > 480 ? 'sm:mb-6 font-semibold text-xl text-center m-auto' : 'm-auto text-center sm:mb-[24px] text-sm leading-5'">
          Select items from your device to<span class="font-weight-bold-blue"> <br />upload into Kinnect</span>
        </p>
      </div>
      }
      <div
        (drop)="dragged($event)"
        (dragstart)="onDragStart($event)"
        (drag)="onDrag($event)"
        (dragover)="onDrag($event)"
        (dragend)="onDragEnd($event)"
        (dragleave)="myFunction($event)"
        (click)="fileInput.click()"
        [ngClass]="fileList?.length || pre_upload_enable ? 'h-[109px]' : 'h-[390px]'"
        class="bg-[#EBF0FA] border-dashed rounded-sm border-2 text-center"
      >
        <img
          src="assets/images/upload-image-icon-form.svg"
          [ngClass]="fileList?.length ? 'mt-[12px]' : 'mt-[146px]'"
          class="p-2 bg-[#FFFFFF] rounded-full mb-[12px]"
        />
        <p class="m-auto leading-9 text-sm font-normal text-[#515765]">
          <span class="font-bold text-[#25508e]">Drag and Drop</span> or <span class="font-bold text-[#25508e]">Browse files</span> from your current
          device
        </p>
        <input hidden type="file" #fileInput [multiple]="!single_upload" (change)="uploadFile($event)" />
      </div>
    </div>
    @if (fileList?.length || pre_upload_enable) {
    <div
      (drop)="dragged($event)"
      (dragstart)="onDragStart($event)"
      (drag)="onDrag($event)"
      (dragover)="onDrag($event)"
      (dragend)="onDragEnd($event)"
      (dragleave)="myFunction($event)"
      class="flex flex-col w-full sm:h-[100%] h-[65vh]"
      [style.max-width]="!is_mobile_delivery ? 'calc(100% - 48px)' : '880px'"
      style="width: calc(100% - 48px) !important; margin: auto; overflow: auto; height: 380px !important; margin-bottom: 12px"
    >
      <div class="flex flex-col my-3 bg-[#ffffff]">
        <div class="flex justify-center border-[#53565B38] border-b border-solid mb-1">
          <p class="text-base px-3 font-semibold decoration-[#333436] mt-3">{{ completedCount }} of {{ totalFileCount }} uploads complete</p>
        </div>
        <div>
          <div class="flex justify-between">
            <p class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold pl-14">Name</p>
            <div class="flex">
              <p style="margin-right: 148px !important" class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold">Size</p>
              <p style="margin-right: 160px !important" class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold pr-12">Vault</p>
            </div>
          </div>
          <div class="overflow-auto mt-3">
            @for (file of fileList; track file; let i = $index) { @if(!file.deleted){
            <div class="flex justify-between border-solid rounded border-[#53565B38] border mb-3 h-[52px] bg-white px-3">
              @if(file.ai_processing){
              <div class="flex justify-center" style="width: 100%; padding-top: 7px">
                <ng-lottie [options]="animation" width="36px" height="36px" class="w-[36px] h-[36px]"></ng-lottie>
                <p class="text-[#53565B] font-semibold text-base m-0" style="line-height: 36px !important">
                  One moment while <span class="text-[#25508E] font-bold"> Kinnect AI </span> processes this...
                </p>
              </div>
              }@else{
              <mat-checkbox
                style="margin-top: 6px"
                type="checkbox"
                class="checkbox-input"
                [(ngModel)]="file.selected"
                (change)="onValueChange($event, file)"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
              <p class="m-0" style="height: 50px; line-height: 50px; width: 36%" [matTooltip]="file.name">
                @if (file.status == 'fail') {
                <img src="assets/images/fail-icon.svg" />
                } @if (file.status != 'fail') {
                <img src="assets/images/file-icon.svg" />
                }
                {{ file.name | truncateStrPipe : 16 }}
              </p>
              <div class="flex">
                <p
                  class="pr-4 text-[#515765] text-sm font-semibold text-truncate"
                  style="width: 80px; padding-right: 12px; line-height: 50px !important"
                >
                  {{ file.size | sizeConvertor }}
                </p>
                <div style="min-width: 320px">
                  @if (file.status == 'running') {
                  <button class="bg-transparent" style="margin-top: 9px; width: 320px">
                    <mat-spinner [diameter]="20" style="margin: auto"> </mat-spinner>
                  </button>
                  } @if (file.status == 'fail') {
                  <img src="assets/images/info-error-messag.svg" style="height: 20px; margin-top: 12px" [matTooltip]="file.error_message" />
                  } @if (file.status == 'success') {
                  <div style="display: flex">
                    @if((currentVaultId || file.saved) && !suggestion_id){
                    <button
                      [matTooltip]="file.vault_details?.name"
                      class="text-[#707070] flex items-center justify-center w-[210px] h-[52px] rounded-[1px] border-[#D3DCE8B2] bg-[#E4E4E4] font-bold text-[13px]"
                      style="
                        border-radius: 0px !important;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 52px;
                        justify-content: center;
                        margin-right: 12px;
                      "
                    >
                      {{ file.vault_details?.name ? (file.vault_details?.name | truncateStrPipe : 12) : '' }}
                    </button>
                    <button class="p-0 bg-[#c1c2c5] mt-2 leading-8 text-xs font-semibold h-[36px] w-[76px] rounded-[4px] text-[#fff]">Saved</button>

                    }@else if(suggestion_id && file.saved && currentVaultDetails){
                    <button
                      [matTooltip]="currentVaultDetails?.name"
                      class="text-[#707070] flex items-center justify-center w-[210px] h-[52px] rounded-[1px] border-[#D3DCE8B2] bg-[#E4E4E4] font-bold text-[13px]"
                      style="
                        border-radius: 0px !important;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 52px;
                        justify-content: center;
                        margin-right: 12px;
                      "
                    >
                      {{ currentVaultDetails?.name | truncateStrPipe : 12 }}
                      <img src="assets/images/Chevron_Down.svg" style="height: 30px" />
                    </button>
                    <button class="p-0 bg-[#c1c2c5] mt-2 leading-8 text-xs font-semibold h-[36px] w-[76px] rounded-[4px] text-[#fff]">Saved</button>

                    }@else{
                    <button
                      [ngClass]="
                        file?.suggestion?.id && file?.vault_details && file?.vault_details?.id === file?.suggestion?.id && !suggestion_id ? 'ai-border-grid' : ''
                      "
                      [matMenuTriggerFor]="menuItemVault"
                      (click)="$event.stopPropagation(); searchText = ''"
                      class="border[#D3DCE8B2] text-[#25508E] flex items-center justify-between w-[210px] h-[50px] rounded-[1px] border-[#D3DCE8B2] bg-[#fff] font-bold text-[13px]"
                      style="width: 210px !important; border: 1px solid #d3dce8b2; margin-right: 12px; padding: 1px"
                    >
                      @if(file?.suggestion?.id && file?.vault_details && file?.vault_details?.id === file?.suggestion?.id && !suggestion_id){
                      <img src="assets/images/ai_suggestion_small.svg" class="w-4 h-4 mr-2" />
                      }@else{
                      <span style="width: 12px"></span>
                      } @if(suggestion_id && currentVaultDetails){
                      {{ currentVaultDetails.name | truncateStrPipe : 12 }}
                      }@else{
                      {{ file?.vault_details?.name ? (file?.vault_details?.name | truncateStrPipe : 12) : 'Select Vault' }}
                      } @if(file?.vault_details?.id == -1 && !suggestion_id){
                      <span class="bg-[#D1F6E1] leading-6 mx-1 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded" style="text-align: center">
                        New
                      </span>
                      }
                      <img src="assets/images/Chevron_Down.svg" style="height: 30px" />
                    </button>
                    <mat-menu #menuItemVault="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel remove-paadin-bottom-menu">
                      <div class="app__centered-item w-full h-full" style="padding: 12px; border-bottom: 1px solid #b1acb066">
                        <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
                        <input
                          class="h-full w-full ml-2 border-none outline-none text-[13px]"
                          type="text"
                          [(ngModel)]="searchText"
                          [placeholder]="'Search Vault'"
                          (click)="$event.stopPropagation()"
                          (input)="onInputChange($event.target.value)"
                        />
                        @if (searchText) {
                        <span
                          (click)="clearSearchAction(); $event.stopPropagation()"
                          class="material-icons relative bg-white text-[#898F9E] text-[22px] leading-7 hover:cursor-pointer"
                          >clear</span
                        >
                        }
                      </div>
                      <div style="height: 200px; max-height: 200px; overflow-y: auto; width: 280px; padding-top: 12px">
                        @if(file?.suggestion?.id){
                        <button
                          mat-menu-item
                          class="popup-menu-item h-16"
                          style="width: 264px; height: 48px !important; margin-bottom: 6px"
                          (click)="selectAiSuggestion(file)"
                        >
                          <div class="flex" style="margin-top: 2px">
                            <img src="assets/images/ai_suggestion.svg" class="w-10 p-1 h-10 bg-[#EBF0FA] rounded" alt="icon" />
                            <div class="ml-1" style="width: 154px; margin-top: 12px; display: flex; flex-direction: column">
                              <p class="text-[12px] font-semibold text-[#18191c]" style="margin-bottom: 6px">
                                {{ file?.suggestion?.name | truncateStrPipe : 12 }}
                              </p>
                              <p
                                class="text-[10px] font-medium m-0 text-base font-normal text-[#010B18]"
                                style="
                                  background: linear-gradient(180deg, #3e75ff, #8400ff, #e367ff);
                                  -webkit-background-clip: text;
                                  font-size: 10px !important;
                                  -webkit-text-fill-color: transparent;
                                "
                              >
                                Kinnect Ai Suggestion
                              </p>
                            </div>
                            @if(file?.suggestion?.id == -1){
                            <span
                              class="bg-[#D1F6E1] leading-6 mx-1 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded"
                              style="text-align: center; margin-top: 8px"
                            >
                              New
                            </span>
                            }
                          </div>
                        </button>
                        } @for (vault of vaultList| filterList : searchText; track vault) { @if(vault?.id !== file?.suggestion?.id){
                        <button
                          mat-menu-item
                          class="popup-menu-item h-16"
                          style="width: 264px; height: 48px !important; margin-bottom: 6px"
                          (click)="selectVault(file, vault)"
                        >
                          <div class="flex" style="margin-top: 2px">
                            <img [src]="'assets/images/' + vault.type + '-small.svg'" class="w-10 p-1 h-10 bg-[#EBF0FA] rounded" alt="icon" />
                            <div class="ml-1" style="margin-top: 12px; display: flex; flex-direction: column">
                              <p class="text-[12px] font-semibold text-[#18191c]">{{ vault.name | truncateStrPipe : 28 }}</p>
                              <p class="text-[#707070] text-[10px] font-medium">{{ vault.type }}</p>
                            </div>
                          </div>
                        </button>
                        } } @if (vaultList?.length >0 && (vaultList | filterList : searchText).length == 0) {
                        <div class="text-center text-[#898F9E] text-[14px]">No vaults found</div>
                        }
                      </div>
                      <button
                        mat-menu-item
                        disableRipple
                        class="cy-add-new-vault-btn-menu popup-menu-item p-0 h-[42px] bg-[#EBF0FA]"
                        style="justify-content: center"
                        (click)="addNewVault(file, i)"
                      >
                        <p class="menuitem-text text-[#25508E] text-[14px] font-bold">
                          <mat-icon class="text-[#25508E] m-0" style="font-size: 23px; left: 8px; top: 1px; position: relative">add</mat-icon>
                          Create New
                        </p>
                      </button>
                    </mat-menu>
                    @if (file.vault_details?.name || (suggestion_id && currentVaultDetails)) {
                    <button
                      (click)="saveFile(file, i, false)"
                      class="p-0 text-[#fff] mt-2 leading-8 text-xs font-semibold h-[36px] w-[76px] rounded-[4px] bg-[#25508E]"
                    >
                      Save
                    </button>
                    }@else{
                    <button class="p-0 bg-[#c1c2c5] mt-2 leading-8 text-xs font-semibold h-[36px] w-[76px] rounded-[4px] text-[#fff]">Save</button>
                    } }

                    <button
                      style="padding: 0px; width: 30px; color: #25508e; line-height: 52px; height: 52px"
                      mat-icon-button
                      aria-label="three dot icon"
                      [matMenuTriggerFor]="menu"
                      (click)="$event.stopPropagation()"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                  }
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item class="popup-menu-item" (click)="renameFile(file, i)">
                      <p class="text-sm font-semibold m-0 text-[#18191C]">
                        <span
                          style="color: #25508e !important; margin-right: 5px !important; position: relative; top: 2px; font-size: 15px !important"
                          class="material-icons material-icons-round menuitem-icon"
                          >edit</span
                        >Rename
                      </p>
                    </button>
                    <button mat-menu-item class="popup-menu-item" (click)="deleteFile(file, i)">
                      <p class="text-sm font-semibold m-0" style="color: red">
                        <span
                          style="color: red !important; margin-right: 5px !important; position: relative; top: 2px; font-size: 15px !important"
                          class="material-icons material-icons-round menuitem-icon"
                          >delete</span
                        >Delete
                      </p>
                    </button>
                  </mat-menu>
                </div>
              </div>
              }
            </div>
            } }
          </div>
        </div>
      </div>
    </div>
    }
  </section>
</div>

@if(fileList?.length){
<upload-file-float-bar [selectedItemsArray]="selectedItemsArray" (actionEvent)="actionEvent($event)"> </upload-file-float-bar>
}
